"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePrintableDesignLayers = updatePrintableDesignLayers;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const compareByReadingOrder_1 = __importDefault(require("./compareByReadingOrder"));
const transferUserDataForEditableDesignAssetLayers_1 = __importDefault(require("./transferUserDataForEditableDesignAssetLayers"));
const transferUserDataForEditableTextLayers_1 = __importDefault(require("./transferUserDataForEditableTextLayers"));
const updatePrintableDesignUserPhotoLayers_1 = require("./updatePrintableDesignUserPhotoLayers");
function updatePrintableDesignLayers(_ref) {
  let {
    oldSurface,
    newSurface,
    workspaceRotatedForPrintable,
    existingPrintableLayers,
    newTemplateLayers,
    ignoreEditableTextTemplateLayers,
    shouldCopyExistingUserPhotoLayers
  } = _ref;
  const newLayers = [];
  const newLayerTypes = new Set(newTemplateLayers.map(layer => layer.type));
  if (ignoreEditableTextTemplateLayers) {
    newLayerTypes.add('editable_text');
  }
  if (shouldCopyExistingUserPhotoLayers) {
    newLayerTypes.add('user_photo');
  }
  newLayerTypes.forEach(layerType => {
    switch (layerType) {
      case 'user_photo':
        newLayers.push(...(0, updatePrintableDesignUserPhotoLayers_1.updatePrintableDesignUserPhotoLayers)({
          oldSurface,
          newSurface,
          workspaceRotatedForPrintable,
          existingPrintableLayers,
          newTemplateLayers,
          shouldCopyExistingUserPhotoLayers
        }));
        break;
      case 'editable_text':
        newLayers.push(...(0, transferUserDataForEditableTextLayers_1.default)(newSurface || oldSurface, existingPrintableLayers, newTemplateLayers, ignoreEditableTextTemplateLayers));
        break;
      case 'editable_design_asset':
        newLayers.push(...(0, transferUserDataForEditableDesignAssetLayers_1.default)(existingPrintableLayers, newTemplateLayers));
        break;
      default:
        newLayers.push(...newTemplateLayers.filter(layer => layer.type === layerType).map(layer => (0, lodash_clonedeep_1.default)(layer)));
        break;
    }
  });
  newLayers.sort(compareByReadingOrder_1.default);
  return newLayers;
}